import React from 'react';
import { useTranslation } from 'react-i18next';
import TextField from 'apollo-react/components/TextField';
import Info from 'apollo-react-icons/Info';
import Tooltip from 'apollo-react/components/Tooltip';

const TextInput = ({
  field = {},
  meta = {},
  label,
  onChange,
  value,
  required, // eslint-disable-line no-unused-vars
  placeholder,
  fullWidth = true,
  multiline = false,
  textareaWidth,
  textareaHeight,
  minRows,
  showInfoIcon = true,
  tooltipText,
  style,
  disabled,
  helpText,
}) => {
  const { t } = useTranslation();
  // Strip minRows from field so we never forward invalid values to TextField (prop-types expect number|string)
  // eslint-disable-next-line no-unused-vars
  const { minRows: _fieldMinRows, ...restField } = field;
  const validMinRows =
    typeof minRows === 'number' && Number.isFinite(minRows)
      ? minRows
      : typeof minRows === 'string' && minRows !== ''
        ? minRows
        : undefined;
  return (
    <TextField
      {...restField}
      label={
        label && (
          <span
            style={{
              display: 'flex',
              alignItems: 'flex-start',
              gap: 4,
              lineHeight: '21px',
            }}
          >
            {label}{' '}
            {showInfoIcon && (
              <Tooltip
                title={
                  tooltipText || t('common.enterYourField', { field: label })
                }
                placement="top"
              >
                <Info
                  fontSize="extraSmall"
                  style={{ color: '#595959', cursor: 'pointer' }}
                />
              </Tooltip>
            )}
          </span>
        )
      }
      placeholder={placeholder}
      value={value}
      error={meta.touched && meta.error}
      helperText={meta.touched && meta.error ? meta.error : helpText || ''}
      onChange={(e) => onChange(e.target.value)}
      fullWidth={fullWidth}
      multiline={multiline}
      {...(validMinRows !== undefined ? { minRows: validMinRows } : {})}
      sx={{
        '& textarea': {
          width: textareaWidth || (fullWidth ? '100%' : 240),
          height: textareaHeight || '100px !important',
        },
      }}
      style={style}
      disabled={disabled}
    />
  );
};

export default TextInput;
